import { render, staticRenderFns } from "./FieldsetForm.vue?vue&type=template&id=731de04b"
import script from "./FieldsetForm.vue?vue&type=script&lang=js"
export * from "./FieldsetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports